export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/menu-arrow.b6192089.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};